import React, { useEffect, useState, useRef, useMemo } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../../features/RadConnStyle";
import styled from "styled-components";

import BoostrapTable from "react-bootstrap-table-next";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { GetConfirmTitle } from "../../components/ConfirmDialog";
import cellEditFactory from "react-bootstrap-table2-editor";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import { FormSelectBlack } from "../../components/PageParams";
import { SubSpecialService } from "../../../model/sub-specialty";
import { BranchService } from "../../../model/branch";

export default function SpecialtySub(props) {
  const user = useSelector((state) => state.user);
  // ********** Variable **********
  const [data, setData] = useState([]);
  const [showOption, setOption] = props.showOption;
  const [branchs, setBranchs] = useState([]);
  const [selBranch, setSelBranch] = useState(0);
  const objREF = useRef([]);
  var dispatch = useDispatch();

  useEffect(() => {
    if (showOption) {
      loadBranch();

      return () => {
        setBranchs([]);
        setData([]);
      };
    }
  }, [showOption]);

  useEffect(() => {
    loadList();
  }, [branchs]);

  //**  โหลดสาขา  */
  const loadBranch = async () => {
    let res = await BranchService.getBranchList();
    if (res?.length > 0) {
      setBranchs(res ?? []);
    }
  };

  /* 
  ----------------------
     โหลดรายการใหม่
  ----------------------
  */
  const loadList = async () => {
    let res = await SubSpecialService.GetListForBranch({
      brchId: selBranch,
      subSpcId: 0,
    });
    setData(res?.rows ?? []);
  };

  /* 
  ----------------------
     เพิ่มใหม่
  ----------------------
  */
  const doAddNew = async () => {
    let ooo = objREF.current;

    if (selBranch > 0) {
      dispatch(
        setReminder({
          show: true,
          message: "เพิ่มรายการใหม่ได้กับค่าเริ่มต้นสาขาเท่านั้น",
          type: "error",
        }),
      );
      return;
    }

    if (
      ooo.GdSpcSubName.value === "" ||
      ooo.LimitEmer.value === "" ||
      ooo.LimitNorm.value === "" ||
      ooo.LimitUrgen.value === ""
    ) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาระบุข้อมูลให้ถูกต้อง",
          type: "error",
        }),
      );
      return;
    }

    let saveData = {
      Data: {
        GdSpcSubId: -1,
        GdSpcSubName: ooo.GdSpcSubName.value,
        LimitEmer: ooo.LimitEmer?.value,
        LimitNorm: ooo.LimitNorm?.value,
        LimitUrgen: ooo.LimitUrgen?.value,
      },
      UserInfo: props.user.userid,
    };

    let res = await SubSpecialService.SaveData(saveData);
  };

  //  ********** Update Data **********
  const beforeSaveCell = (oldValue, newValue, row, column, done) => {
    if (oldValue === newValue) {
      done(false);
      return;
    }

    done(true);

    const save = async () => {
      let res = await SubSpecialService.SaveData(xdata);
      if (res) {
      }
    };

    let xdata = { Data: row, BranchId: selBranch, UserInfo: props.user.userid };
    save();

    // axios
    //   .post(
    //     process.env.REACT_APP_API + "api/goods/specialty-sub-save",
    //     xdata,
    //     HttpJsonHeader,
    //   )
    //   .then((res) => {
    //     done(true);
    //   })
    //   .catch((err) => console.log(err));
  };

  // ********** Delete **********
  const popupDelete = (row) => {
    props.setShowConfirm(true);
    let data = {
      GdSpcSubId: row.GdSpcSubId,
      DeletedBy: props.user.userid,
    };

    props.setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/goods/specialty-sub-delete",
            data,
            HttpJsonHeader,
          )
          .then((res) => {
            loadList();
          })
          .catch((err) => console.log(err));
      },
    });
  };

  const removeBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  const headerBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>บันทึก</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => doAddNew()}
          >
            <AiOutlinePlus />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  //  ********** Field Style **********

  const fieldStyle = () => {
    return {
      color: "var(--table-text-color)",
      textAlign: "center",
    };
  };
  const headerColStyle = () => {
    return {
      justifyContent: "center",
      alignItems: "center",
      verticalAlign: "middle",
      border: "none",
      fontSize: "15px",
      backgroundColor: "#222121",
      // backgroundImage: "linear-gradient(#3d3dd6,  #3d3dd6, #3d3dd6)",
    };
  };
  const headerFlagStyle = () => {
    return { ...headerColStyle(), width: "50px" };
  };

  const headerTextBox = (column, colIndex, { sortElement, filterElement }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "5px 0 0 0",
        }}
      >
        <div
          style={{
            backgroundColor: "#1f1e1e",
            padding: "2px",
            borderRadius: "2px",
          }}
        >
          <div style={{ color: "#085af3", margin: "0 0 0 0" }}>
            <div>{column.text}</div>
            <div>{column.text2}</div>
          </div>

          <input
            type="text"
            className="textbox-40h"
            style={{ textAlign: "center" }}
            ref={(el) => {
              objREF.current[column.dataField] = el;
            }}
          />
        </div>
      </div>
    );
  };

  //  ********** Columns  **********
  const columns = [
    {
      dataField: "GdSpcSubName",
      text: "ชื่อ",
      text2: "Sub Specialty",
      align: "left",
      style: () => {
        return { ...fieldStyle(), paddingLeft: "25px" };
      },
      headerStyle: () => {
        return { ...headerColStyle(), minWidth: "200px" };
      },
      headerFormatter: headerTextBox,
    },
    {
      dataField: "LimitNorm",
      text: "ระยะเวลาอ่านผล ",
      text2: "ทั่วไป (นาที)",
      align: "center",
      style: () => {
        return { ...fieldStyle(), paddingLeft: "25px" };
      },
      headerStyle: () => {
        return { ...headerColStyle(), minWidth: "200px" };
      },
      headerFormatter: headerTextBox,
    },
    {
      dataField: "LimitEmer",
      text: "ระยะเวลาอ่านผล",
      text2: "Emergency (นาที)",
      align: "center",
      style: () => {
        return { ...fieldStyle(), paddingLeft: "25px" };
      },
      headerStyle: () => {
        return { ...headerColStyle(), minWidth: "200px" };
      },
      headerFormatter: headerTextBox,
    },
    {
      dataField: "LimitUrgen",
      text: "ระยะเวลาอ่านผล",
      text2: "Urgency (นาที)",
      align: "center",
      style: () => {
        return { ...fieldStyle(), paddingLeft: "25px" };
      },
      headerStyle: () => {
        return { ...headerColStyle(), minWidth: "200px" };
      },
      headerFormatter: headerTextBox,
    },
    {
      dataField: "LimitFast",
      text: "ระยะเวลาอ่านผล",
      text2: "Fast Track (นาที)",
      align: "center",
      style: () => {
        return { ...fieldStyle(), paddingLeft: "25px" };
      },
      headerStyle: () => {
        return { ...headerColStyle(), minWidth: "100px" };
      },
      headerFormatter: headerTextBox,
    },

    {
      dataField: null,
      text: "",
      headerStyle: headerFlagStyle,
      align: "center",
      editable: false,
      formatter: removeBox,
      headerFormatter: headerBox,
    },
  ];

  const selectBranch = (e) => {
    setSelBranch(e.target.value);
  };

  useEffect(() => {
    if (showOption) {
      loadList();
    }
  }, [selBranch]);

  return (
    <MyModal
      backdrop="static"
      show={showOption}
      size="lg"
      onHide={() => {
        setOption(false);
      }}
    >
      <ModalHeaderBlack closeButton> Sub-Specialty</ModalHeaderBlack>
      <ModalBodyBlack>
        <MainPane>
          <LeftPane>
            <div style={{ display: "block" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  padding: "10px",
                }}
              >
                <span
                  style={{
                    color: "var(--caption-fore-color)",
                    minWidth: "100px",
                    padding: "10px",
                  }}
                >
                  เลือกสาขา
                </span>
                <FormSelectBlack
                  {...{
                    rows: branchs,
                    fieldId: "brchid",
                    fieldValue: "brchname",
                    onChange: selectBranch,
                    addFirstRow: true,
                    firstRowText: "ค่าเริ่มต้นสาขา",
                    initValue: 0,
                  }}
                />
              </div>
            </div>
            <BoostrapTable
              bootstrap4
              keyField="GdSpcSubId"
              data={data}
              columns={columns}
              striped
              hover
              condensed
              headerClasses="headerWrapper"
              rowClasses={"table-next-rows-style"}
              // filter= {filterFactory()}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                beforeSaveCell: beforeSaveCell,
              })}

              // pagination = {paginationFactory( PageOptions)}
              // rowStyle = {rowStyle2}
              // rowEvents= {rowEvents}
            />
          </LeftPane>

          <RightPane></RightPane>
        </MainPane>
      </ModalBodyBlack>
    </MyModal>
  );
}

const MainPane = styled.div`
  display: flex;
  justify-content: center;
  min-height: 80vh;
  max-height: 80vh;
  overflow-y: scroll;

  /* background-color:red; */
`;

const LeftPane = styled.div``;

const RightPane = styled.div``;
